import { Component, ViewChild, TemplateRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { ParseService } from '../../../../../shared/common/parse/parse.service';
import { ToastrService } from 'ngx-toastr';
import { ExperienceData } from '../../../../../shared/common/interface';
import { ToastBaseModel } from '../../../../../shared/common/toast-data-model';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { ProfileService } from '../../profile.service';
import { QueryInterface } from '../../../../../shared/common/parse/query-interface';
import { GetSetOperations } from '../../../../../shared/common/helper/profile';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { DateConvertor } from 'app/shared/common/helper/dateConvertor';
import { SessionHandler } from 'app/shared/common/parse/session-handler';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';
@Component({
    selector: 'app-experiences-skills',
    templateUrl: './experiences-skills.component.html',
    styleUrls: ['./experiences-skills.component.scss']
})

export class ExperiencesSkillsComponent {

    exp = [];
    getExperiences = [];
    experienceForm: FormGroup;
    designat: string = '';
    company: string = '';
    fromdate: Date;
    diffdate: string = '';
    todate: Date;
    id: string = '';
    datestart = [];
    dateend = [];
    roleresponsability: string = '';
    experience = [];
    tabexperience = [];
    t = 1;
    displayedColumns = ['position', 'designation', 'company', 'from', 'to', 'role', 'action'];
    dataSource = new MatTableDataSource(experienceData);
    myControl = new FormControl();
    isEdit: boolean;
    editIndex: number;
    btnText: string = 'Add a new skill';
    skillsList = [];
    rateList = [];
    skillText: string = '';
    selectedSkill: string = '';
    skills = [];
    synthese = [this.skills, []];
    about: any;
    rowData = [];
    userroles: any;
    userroles1: any;
    profileroles: any;
    profileDetails1: any;
    dataRefresher: any;
    result = [];
    deleteId: any;
    instance: any;
    cols: any[];
    profileId: any;
    objectId = '';
    userId = '';
    empRole = '';
    currentRate: any;
    hideSkill = [];
    myOptions: any;
    routeId = '';
    @ViewChild('deleteExpPopup', { static: false }) deleteExpPopup: TemplateRef<any>;

    constructor(private dateConvertor: DateConvertor,
        private toastMessage: ToastBaseModel,
        public dialog: MatDialog,
        private parseService: ParseService,
        private toastr: ToastrService,
        private formBuilder: FormBuilder,
        private profileService: ProfileService,
        private queryInterface: QueryInterface,
        private profileInterface: GetSetOperations,
        private route: ActivatedRoute,
        private sessionHandler: SessionHandler,
        private storageConfiguration: StorageConfiguration,

    ) {
        this.profileService.aboutOnChanged.subscribe(about => {
            this.about = about;
        });

        this.cols = [
            { header: 'S.No', field: 'position' },
            { header: 'Designation', field: 'designation', cellStyle: { color: '#049ae5', cursor: 'pointer' } },
            { header: 'Company', field: 'company' },
            { header: 'From', field: 'from' },
            { header: 'To', field: 'to' },
            { header: 'Role', field: 'role' },
            { header: 'Action', field: 'action' }
        ];

        this.experienceForm = this.formBuilder.group({
            id: [''],
            designation: ['', Validators.required],
            company: ['', Validators.required],
            from: ['', Validators.required],
            to: ['', Validators.required],
            role: ['']
        });
    }
    filteredOptions: Observable<any[]>;

    ngOnInit() {
        this.empRole = this.storageConfiguration.sessionGetItem(this.storageConfiguration.role);
        this.objectId = this.parseService.instance.User.current().get('profile').id;
        this.userId = this.parseService.instance.User.current().id;

        let id = '';
        this.route.params.subscribe(params => {
            id = params['id'];
            this.routeId = id;
        });
        if (id != undefined) {
            this.objectId = id;
        }

        if (this.objectId) {
            var user = new this.parseService.instance.Object('Profile');
            user.id = this.objectId;
        }

        this.getDatasettingsSkills();
        this.getProfileToUser();
        this.getSkillDetails();
    }

    getProfileToUser() {
        this.queryInterface.executeQuery(this.parseService, 'User', [
            { condition: 'equalTo', field: 'profile', value: { __type: 'Pointer', className: 'Profile', objectId: this.objectId } },
            { condition: 'include', value: 'profile' }]).then(results => {
                let result = results[0]
                this.objectId = result.id
                var user = new this.parseService.instance.Object('User');

                user.id = result.id
                this.getDatasettingsSkills();
                this.getExperience();
            });
    }

    deleteExperiencePopupup(event) {
        this.deleteId = event;
        this.dialog.open(this.deleteExpPopup, {
            width: '300px'
        });
    }
    /*
    ** ==========================================================
    ** Table Values Get Function
    ** ==========================================================
    */
    uniqBy(a, key) {
        var index = [];
        return a.filter(function (item) {
            var k = key(item);
            return index.indexOf(k) >= 0 ? false : index.push(k);
        });
    }

    getExperience() {
        this.result = [];
        this.queryInterface.executeQuery(this.parseService, 'User', [{ condition: 'equalTo', field: 'objectId', value: this.objectId },
        { condition: 'include', value: 'profile' }]).then(results => {
            for (let i = 0; i < results.length; i++) {
                let jsonText = JSON.stringify(results[i]);
                let user = JSON.parse(jsonText);
                this.profileId = user.profile.objectId
                this.experience = user.profile.experienceInfo;
                this.experience.forEach(element => {
                    this.result.push({
                        position: i = i + 1,
                        id: element.id,
                        designation: element.designation,
                        company: element.company,
                        from: element.from,
                        to: element.to,
                        role: element.role,
                        objectid: element.objectId
                    });
                });
                var results = this.uniqBy(this.result, JSON.stringify)
                this.rowData = results;
            }
        });
    }

    /*
    ** ==========================================================
    ** Table Values Remove Function
    ** ==========================================================
    */

    async removeExperience() {
        let index = this.experience.findIndex(x => x.id === this.deleteId)
        this.experience.splice(index, 1);
        this.dataSource = new MatTableDataSource(this.experience);
        this.profileInterface.updateExperience(this.profileId, this.experience).then(rest => {
            this.getExperience();
            this.toastr.success('Deleted Successfully');
            this.dialog.closeAll();
        });
    }

    /*
    ** ==========================================================
    ** Table Values Edit Function
    ** ==========================================================
    */

    editExperience(i) {
        this.experience.forEach(element => {
            if (element.id == i) {
                this.experienceForm.patchValue({
                    id: element.id,
                    designation: element.designation,
                    company: element.company,
                    from: element.from,
                    to: element.to,
                    role: element.role
                });
                this.dialog.open(this.expDialog);
                this.isEdit = true;
                this.id = element.id
                this.designat = element.designation;
                this.company = element.company;
                this.fromdate = element.from
                this.todate = element.to;
                this.roleresponsability = element.role;
            }
            this.editIndex = i;
        });
    }

    /*
    ** ==========================================================
    ** Table Values Update Function
    ** ==========================================================
    */

    async updateExperience(model) {
        if (this.experienceForm.valid) {
            let i = this.editIndex;
            this.experience.forEach((element) => {
                if (element.id == i) {
                    element.designation = model.designation;
                    element.company = model.company;
                    element.from = this.dateConvertor.addGMTOffset(new Date(model.from)).toISOString();
                    element.to = this.dateConvertor.addGMTOffset(new Date(model.to)).toISOString();
                    element.role = model.role;
                }
            });
            this.profileInterface.updateExperience(this.profileId, this.experience).then(rest => {
                this.dataSource = new MatTableDataSource(this.experience);
                this.getExperience();
                this.toastr.success(this.toastMessage.Save);
                this.experienceForm.reset();
                this.dialog.closeAll();
            });
        }
        else {
            this.toastr.warning('Please enter the required fields');
        }
    }

    /*
    ** ==========================================================
    ** Table Values Add Function
    ** ==========================================================
    */

    getRandomId() {
        return Math.floor((Math.random() * 100) + 1);
    }

    async addExperienceDetails() {
        let experienceValues = this.experienceForm.value;
        if (this.experienceForm.valid) {
            let data = {
                id: this.getRandomId(),
                designation: experienceValues.designation,
                company: experienceValues.company,
                from: this.dateConvertor.addGMTOffset(new Date(experienceValues.from)).toISOString(),
                to: this.dateConvertor.addGMTOffset(new Date(experienceValues.to)).toISOString(),
                role: experienceValues.role
            };
            this.experience.push(data);
            this.profileInterface.updateExperience(this.profileId, this.experience).then(rest => {
                this.dataSource = new MatTableDataSource(this.experience);
                this.getExperience();
                this.toastr.success(this.toastMessage.Save);

                this.experienceForm.reset();
                this.dialog.closeAll();
            });
        }
        else {
            this.toastr.warning('Please enter the required fields');
        }
    }

    addGMTOffset(somedate) {
        let date = somedate._d;
        if (!date) {
            date = somedate;
        }
        var datewithoffset = new Date(
            date.getTime() - date.getTimezoneOffset() * 60000
        );
        return datewithoffset;
    }

    /*
    ** ==========================================================
    ** Table Open Dialog Function
    ** ==========================================================
    */

    @ViewChild('expDialog', { static: false }) expDialog: TemplateRef<any>;
    experiencePopup() {
        this.isEdit = false;
        this.dialog.open(this.expDialog, {
            width: '700px',
        });
    }

    closepopup() {
        this.dialog.closeAll();
        this.experienceForm.reset();
    }

    /*
    ** ==========================================================
    ** Skills Values Get Function
    ** ==========================================================
    */

    async getDatasettingsSkills() {
        await this.getSkills();
    }

    async getSkillDetails() {
        let skillDetails = this.parseService.instance.Object.extend('User');
        let query = new this.parseService.instance.Query(skillDetails);
        query.equalTo('objectId', this.objectId);
        query.include('profile');
        await query.find().then(skDetails => {
            let skillsValue = [];
            let profile = skDetails[0].get('profile');
            skillsValue = profile.get('skillSet');
            skillsValue.forEach(element => {
                this.skillsList.forEach((innerElement, index) => {
                    if (innerElement == element.name) {
                        this.skillsList.splice(index, 1);
                    }
                });
            });
            this.skills = skillsValue;
            this.getFilteredValue();
            for (let i = 1; i < this.skills[i](name); i++) {
                let skilltoremove = this.skills[i](name)[i];
                let j = 0;
                let test = false;
                while (test == false && j < this.myOptions.length) {
                    if (this.myOptions[j].value == skilltoremove) {
                        this.myOptions.splice(j, 1);
                        test = true;
                    }
                    j = j + 1;
                }
            }
        }).catch(err => {
            this.sessionHandler.handleParseError(err);
        });
    }

    async getSkills() {
        let queryInstance = this.parseService.instance.Object.extend('DataSettings');
        let query = new this.parseService.instance.Query(queryInstance);
        let results = await query.find();
        let jsonText = JSON.stringify(results);
        let skills = JSON.parse(jsonText);
        for (let skill of skills) {
            this.skillsList = skill.skill_set;
        }
        this.getSkillDetails();
    }

    getFilteredValue() {
        if (this.skillsList.length > 0) {
            this.filteredOptions = this.myControl.valueChanges.pipe(
                startWith(''),
                map(skillSets => this._filter(skillSets))
            );
            this.selectedSkill = '';
        }
    }

    private _filter(value: string): any[] {
        const filterValue = value.toLowerCase();
        return this.skillsList.filter(option =>
            option
                .toString()
                .toLowerCase()
                .includes(filterValue)
        );
    }

    /*
    ** ==========================================================
    ** Skills Values Save Function
    ** ==========================================================
    */

    skillSave() {
        let skillDetails = this.parseService.instance.Object.extend('Profile');
        let query = new this.parseService.instance.Query(skillDetails);
        query.equalTo('objectId', this.profileId);
        query.find().then(function (results) {
            if (results.length > 0) {
                let skdetails = results[0];
                skdetails.set('skillSet', this.skills);
                this.dialogRef = this.toastr.success(
                    this.toastMessage.Skill + ' ' + this.toastMessage.Save
                );
                let skillDetailsPopup = this.dialogRef;
                skdetails.save({
                    success: function (_skdetails) {
                        this.skillDetailsPopup;
                    },
                    error: function (error) {
                    }
                });
            } else {
                alert('No profile found for this id');
            }
        }.bind(this)
        ).catch(err => {
            this.sessionHandler.handleParseError(err)
        });
    }

    /*
    ** ==========================================================
    ** Add Skills Values Function
    ** ==========================================================
    */

    addSkillItem() {
        if (this.selectedSkill) {
            this.skills.push({ name: this.selectedSkill, rating: 0 });
            this.skillsList.forEach((element, index) => {
                if (element == this.selectedSkill) {
                    this.skillsList.splice(index, 1);
                }
            });
        }
        this.selectedSkill = '';
        this.myControl.setValue('');
        this.skills.forEach(item2 => {
            this.skillsList = this.skillsList.filter(item1 => {
                return JSON.stringify(item1) !== JSON.stringify(item2);
            });
        });
    }

    /*
    ** ==========================================================
    ** Remove Skills Values Function
    ** ==========================================================
    */
    removeSkillItem(i) {
        let test = this.skills;
        this.skillsList.push(this.skills[i].name)
        this.skills.splice(i, 1);
        if (test.length === 0) {
            document.getElementById('skillsave').style.display = 'none';
        }
    }

    range = function (start, end) {
        let result = [];
        for (let i = start; i <= end; i++) {
            result.push(i);
        }
        return result;
    };

    /*
    ** ==========================================================
    ** Skills Dialog Open Function
    ** ==========================================================
    */

    @ViewChild('skillDialog', { static: false }) skillDialog: TemplateRef<any>;
    openDialogWithoutRef() {
        this.dialog.open(this.skillDialog);
    }


}

const experienceData: ExperienceData[] = [];